import * as React from "react";
const SvgFiRrCheapDollar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cheap-dollar_svg__a)">
      <path
        fill="#062147"
        d="M11 15a1 1 0 0 1-2 0h-.268a3.01 3.01 0 0 1-2.598-1.499A1 1 0 0 1 7.865 12.5c.178.308.511.5.867.5H11c.551 0 1-.448 1-1a.77.77 0 0 0-.644-.76l-3.042-.507A2.76 2.76 0 0 1 5.999 8c0-1.654 1.346-3 3-3a1 1 0 0 1 2 0h.268a3.01 3.01 0 0 1 2.598 1.499A1 1 0 1 1 12.134 7.5a1 1 0 0 0-.867-.5H8.999c-.551 0-1 .448-1 1 0 .378.271.698.644.76l3.042.507A2.76 2.76 0 0 1 14 12c0 1.654-1.346 3-3 3m-1.89 2.951A7.985 7.985 0 0 1 2 10c0-4.411 3.589-8 8-8 1.249 0 2.445.28 3.555.831a1 1 0 1 0 .891-1.791A9.9 9.9 0 0 0 10.001 0C4.486 0 0 4.486 0 10c0 5.106 3.933 9.385 9.001 9.945a1 1 0 0 0 .109-1.994m14.597.223a1 1 0 0 0-1.414 0L19 21.467V1a1 1 0 1 0-2 0v20.367l-3.293-3.293a.999.999 0 1 0-1.414 1.414l3.636 3.636A3 3 0 0 0 18.05 24c.767 0 1.537-.292 2.122-.877l3.535-3.536a1 1 0 0 0 0-1.413"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cheap-dollar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCheapDollar;
